import { o_util } from "@gr-common/async/namespaces";
const event = o_util.event ?? {};
const delegate = event.delegate;
const stop = event.stop;
const undelegate = event.undelegate;
const on = event.on;
const unsetAll = event.unsetAll;
const whichTransitionEndEvent = event.whichTransitionEndEvent;
export {
  delegate,
  event,
  on,
  stop,
  undelegate,
  unsetAll,
  whichTransitionEndEvent
};
